import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { SYSTEM_NAVIGATION_MENU } from "../../../../../menu/menus.data";

@Component({
  selector: "app-sidebar-menu",
  templateUrl: "./sidebar-menu.component.html",
  styleUrls: ["./sidebar-menu.component.scss"],
})
export class SidebarMenuComponent implements OnInit {
  SYSTEM_NAVIGATION_MENU = SYSTEM_NAVIGATION_MENU;
  constructor() {}
  ngOnInit(): void {}
}
